import * as React from "react";
import styled from "styled-components";

const ICON_SIZE = 110;

const StyledItemGroupIcon = styled.div`
  position: relative;
  width: ${ICON_SIZE}px;
  height: ${ICON_SIZE}px;
  margin: 0 auto;
  background: linear-gradient(rgba(255, 255, 255, 0), white 13px, rgba(255, 255, 255, 0));

  div {
    position: relative;
    display: flex;
    flex: 1;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  img {
    position: absolute;
  }

  i {
    font-size: 1.7rem;
    margin-bottom: 0.8rem;
    color: white;
  }
`;

const ItemGroupIcon = ({ icon }: { icon: string }) => (
  <StyledItemGroupIcon>
    <img src="./squircle.svg" width={ICON_SIZE + "px"} height={ICON_SIZE + "px"} />
    <div>
      <i className={"fas " + icon} />
    </div>
  </StyledItemGroupIcon>
);

export default ItemGroupIcon;



// WEBPACK FOOTER //
// ./src/components/shared/ItemGroupIcon.tsx